import { ResultsCard } from 'libs/athos/components/ResultCard'

export const ResultItem = ({ item, className, dataIndex, eager = false, imageSizes, imageWidths, mobileSlider = false }) => {
  if ('value' in item) {
    return <div className="result-card" dangerouslySetInnerHTML={{ __html: item.value }} />
  }

  return (
    <ResultsCard
      result={item}
      className={className}
      dataIndex={dataIndex}
      eager={eager}
      imageSizes={imageSizes}
      imageWidths={imageWidths}
      mobileSlider={mobileSlider}
    />
  )
}
